import axios from "axios";
import { Part } from "../Types/part";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/parts`;

export const fetchAllParts = async (): Promise<Part[]> => {
  const res = await axios.get(BASE_URL);
  return res.data;
};

export const fetchPartById = async (id: string): Promise<Part> => {
  const res = await axios.get(`${BASE_URL}/${id}`);
  return res.data;
};
